export function calculateChunkOffset(params: {
  chunkIndex: number;
  currentPageIndex: number;
  rowsPerPage: number;
  rowsPerChunk: number;
}): number {
  return params.currentPageIndex * params.rowsPerPage + params.chunkIndex * params.rowsPerChunk;
}
